import React from "react";
import Career from "./career";

function CareerSection(props) {
  const { careers } = props;

  return careers.length > 0 && (
    <section className='row d-flex justify-content-center' id='experience' name='experience'>
      <div id='object_unit' className='col-12 col-sm-10'>
        <h2>EXPERIENCE</h2>
        <table className='table'>
          <tbody>
            {careers.map(career => {
              return (
                <tr key={career.id}>
                  <Career career={career} {...props} />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default CareerSection;
